import React from 'react';
import { FormattedNumber } from 'react-intl';

import Translation from '@swf/components/Translation/Translation';
import type { Currency } from '@swf/core/enums';
import type { ClubRecentTournPlayerResult } from '@swf/generated/types/api/v0/SwHomeGames';
import { FormattedCurrencyAmount, Table } from '@swf/poker';

import {
  TXTCLI_KO__tab,
  TXTCLI_Place,
  TXTCLI_Player,
  TXTCLI_Points,
  TXTCLI_Prize,
  TXTCLI_Rank
} from './ResultsTable.messages.json';
import styles from './ResultsTable.scss';

interface Props {
  results: ClubRecentTournPlayerResult[];
  currency: Currency;
  isPlayMoney: boolean;
}

interface ResultsData {
  [key: string]: number;
}

const columns = [
  { Header: <Translation {...TXTCLI_Place} />, accessor: 'place' },
  { Header: <Translation {...TXTCLI_Player} />, accessor: 'userId' },
  { Header: <Translation {...TXTCLI_Prize} />, accessor: 'prize' },
  { Header: <Translation {...TXTCLI_Points} />, accessor: 'pointsEarned' },
  { Header: <Translation {...TXTCLI_KO__tab} />, accessor: 'knockouts' },
  { Header: <Translation {...TXTCLI_Rank} />, accessor: 'tournRank' }
];

const ResultsTable: React.FC<Props> = ({ results, isPlayMoney, currency }) => {
  const formatted: unknown = results.map((result) => ({
    ...result,
    prize: (
      <FormattedCurrencyAmount
        amount={result.prize}
        scalePM={result.scalePM}
        isPlayMoney={isPlayMoney}
        currency={currency as Currency}
      />
    ),
    pointsEarned: (
      <FormattedNumber
        value={Number(result.pointsEarned) / 1000}
        style="decimal"
        minimumFractionDigits={Number(result.pointsEarned) % 1 !== 0 ? 2 : 0}
      />
    ),
    knockouts: (
      <FormattedNumber
        value={Number(result.knockouts) / 1000}
        style="decimal"
        maximumFractionDigits={0}
      />
    )
  }));

  return (
    <div className={styles.container}>
      <Table columns={columns} data={formatted as ResultsData[]} />
    </div>
  );
};

export default ResultsTable;
